import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class HasExpansion extends Decision {
    public evaluate() {

        let hasExpansion = false;

        const record = GameState.getCurrentGame().getCurrentRecord();

        if (record instanceof SpinRecord) {
            if (record.expansions && record.expansions.length) {
                hasExpansion = true;
            }
        }

        return hasExpansion ? Exit.True : Exit.False;
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/decisions/has-expansion.ts